import { forwardRef } from 'react';
import { IPostAutoComplete } from '@/redux/post/post';

interface AutoCompleteResultsProps {
  suggestions: IPostAutoComplete[];
  showSuggestions: boolean;
  handleSuggestionClick: (id: string) => void;
}

const AutoCompleteResults = forwardRef<
  HTMLDivElement,
  AutoCompleteResultsProps
>(({ showSuggestions, suggestions, handleSuggestionClick }, ref) => {
  if (!showSuggestions || suggestions.length <= 0) {
    return <div />;
  }

  return (
    <div
      ref={ref}
      className="absolute z-10 mt-1 w-full rounded-md border border-gray-200 bg-white shadow-lg"
    >
      <ul className="max-h-60 overflow-auto py-1 text-base">
        {suggestions.map((suggestion, index) => (
          <li
            key={suggestion._id}
            onClick={() => handleSuggestionClick(suggestion._id)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleSuggestionClick(suggestion._id);
              }
            }}
            tabIndex={index}
            role="option"
            aria-selected={false}
            className="cursor-pointer px-4 py-2 hover:bg-gray-100"
          >
            {suggestion.title}
          </li>
        ))}
      </ul>
    </div>
  );
});

AutoCompleteResults.displayName = 'AutoCompleteResults';

export default AutoCompleteResults;
